<template>
  <div>
    <header>


    </header>
    <div class="nav-sty">
      <div class="nav-ul">
        <div class="img-box">
          <img @click="turnTo('/')" src="/static/images/logo/logonew.png">
        </div>
        <ul>
          <li @click="turnTo('/')">首页</li>
          <li @click="turnTo('/list')">产品中心</li>
          <li>优惠/促销</li>
          <li @click="turnTo('/news/list')">新闻资讯</li>
          <li @click="turnTo('/manual/list')">关于我们</li>
          <li @click="turnTo('/manual/list')">帮助中心</li>
        </ul>
        <div class="header-box">
          <div style="display: flex;">
            <!--<div class="item">-->
              <!--<search class="search"></search>-->
            <!--</div>-->
            <!--<div class="item phone">-->
            <!--<i class="el-icon-phone"></i>-->
            <!--<span>0536-7194090</span>-->
            <!--</div>-->
            <div class="item app">
              <i class="el-icon-mobile-phone"></i>
              <span @click="AppDownload">APP下载</span>
            </div>
            <template v-if="accountname == null || accountname == ''">
              <div class="item register">
                <span @click="turnTo('/Register')">注册</span>
              </div>
              <div class="item login">
                <span @click="turnTo('/Login')">登录</span>
              </div>
            </template>
            <template v-else>
              <div class="item">
                <span @click="turnTo('/My/Info')">{{ accountname}}</span>
              </div>
              <div class="item">
                <span @click="turnTo('/Logout')">注销</span>
              </div>
            </template>

          </div>

        </div>
      </div>
    </div>
  </div>

</template>

<script type="text/javascript">
  import Search from '@/components/Search'

  export default {
    components: {
      Search
    },
    props: {
      screen:{
        type: Object,
        default: () => {}
      },
      isLogin: {
        type: Boolean,
        default: true
      },
      isMe: {
        type: Boolean,
        default: true
      },
      isHome: {
        type: Boolean,
        default: true
      },
      canBack: {
        type: Boolean,
        default: false
      },
      messageNum: {
        type:Number,
        default:0
      }
    },
    data() {
      return {
        time: new Date().format('yyyy年MM月dd日 hh:mm:ss'),
        customname: '',
        accountname: '',
        customno: '',
        timeStr:'',
        url: {
          time: SZH.assets.api + "/Test/GetTime",
        },
        customType: '',
        adminUrl: '',
      }
    },
    computed: {
      isPhone() {
        return this.screen.width <= 450;
      }
    },
    mounted() {
      this.adminUrl = SZH.adminUrl;

      this.initUser();
      this.loadTime();
    },
    methods: {
      AppDownload(){
        window.open('https://www.chemchangyi.com:2004/app/com.chemchangyi.apk')
      },
      back(){
        if(this.isPhone && this.$refs['search']) {
          this.$refs['search'].clear();
        }
        this.$emit('back');
      },
      turnTo(url) {
        this.$router.push({
          path: url,
        })
      },
      initUser() {

        this.customType = localStorage.getItem('ms_webtype');
        this.customname = localStorage.getItem('ms_customname');
        if(localStorage.getItem('ms_accountname') !== 'null'){
          this.accountname = localStorage.getItem('ms_accountname')
        }else{
          this.accountname = '会员中心';
        }
        this.customno = localStorage.getItem('ms_customno');
      },
      loadTime() {
        var self = this;
        self.$http.post(self.url.time, {

        }).then(result => {
          self.time = result.Now?new Date(result.Now): new Date();
          if(result.IsLogin == false){
            localStorage.removeItem('ms_accountname');
          }
          self.timeStr = self.time.format('yyyy年MM月dd日 hh:mm:ss');
          setInterval(() => {
            self.time = new Date(self.time.getTime() + 1000);
            self.timeStr = self.time.format('yyyy年MM月dd日 hh:mm:ss');
          }, 1000);
        }, () => {
          self.time = new Date();
          self.timeStr = self.time.format('yyyy年MM月dd日 hh:mm:ss');
          setInterval(() => {
            self.time = new Date(self.time.getTime() + 1000);
            self.timeStr = self.time.format('yyyy年MM月dd日 hh:mm:ss');
          }, 1000);
        });
      }
    },
    watch: {
      $route(val) {
        this.initUser();
      }
    }
  }


</script>

<style type="text/css" scoped>
  header{
    background: #004BA0;
    height: 0px;
  }
  .header-box{
    margin: 0px auto;
    position: absolute;
    right: 40px;
  }
  .item{
    margin-left: 25px;
    font-size: 13px;
    color: white;
    line-height: 40px;
  }
  .item span{
    cursor: pointer;
  }
  .phone{
    color: white;
    font-size: 16px;
    font-weight: 600;
    line-height: 40px;
  }
  .app{
    color: white;
    font-size: 14px;
    line-height: 40px;
  }
  .nav-sty{
    background: #004BA0;

  }
  .nav-ul{
    width: 1200px;
    margin: 0px auto;
    display: flex;
    padding: 20px 0px;
    align-items: center;
  }
  .img-box{
    width: 214px;
  }
  .img-box img{
    width: 100%;
  }
  .nav-ul ul li{
    list-style: none;
    display: inline-block;
    padding: 10px 20px;
    font-size: 14px;
    color: white;
    cursor: pointer;
  }
</style>
<style>
  .el-badge__content.is-fixed{
    top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Header/Headernew.vue